<template>
    <w-btn
        v-if="show"
        color="red"
        :loading="loading"
        :text="$t('common.delete')"
        icon="mdi-trash-can"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnDelete',
    props: {
        show: Boolean,
        loading: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>